import gql from "graphql-tag";

export const CREATE_TODOIST_ACTIVITY = gql`
  mutation ($input: createTodoistActivityInput) {
    createTodoistActivity(input: $input) {
      _id
      title
      description
      timebox
      created_by {
        _id
        email
        full_name
      }
      project {
        _id
        title
        color
      }
      activity_type
      meta
      time {
        start
        paused {
          created_at
          time
          continue
        }
      }
    }
  }
`;
